import { Box, Button, Flex, Select, useToast } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

import CustomInput from '../../common/CustomInput/CustomInput';
import { useUserContext } from '../../core/context/user.context';
import { isEmpty, isValidEmail } from '../../core/helpers';
import useFetch from '../../core/hooks/useFetch';
import { useFormInput } from '../../core/hooks/useFormInput';

function InvitationSettingsEditor() {
  const { doFetch, result, error, loading } = useFetch(
    `${process.env.REACT_APP_API_URL}/invitation-config`,
  );
  const { doFetch: updateConfig } = useFetch(`${process.env.REACT_APP_API_URL}/invitation-config`);
  const interval = useFormInput('');
  const [intervalType, setIntervalType] = useState('days');
  const { token } = useUserContext();

  const toast = useToast();

  const update = async () => {
    if (interval.value && token) {
      const data = await updateConfig({
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          intervalType: intervalType,
          interval: interval.value,
        }),
      });

      toast({
        title: data.message,
        position: 'top',
        status: 'success',
        duration: 2000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    if (token) {
      doFetch({
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    }
  }, [token]);

  useEffect(() => {
    if (result) {
      interval.setValue(result?.data?.interval || 7);
      setIntervalType(result?.data?.intervalType || 'days');
    }
  }, [result]);

  return (
    <>
      <Flex flexDirection="row" justifyContent="space-between" alignItems="center">
        <h1 className="h3" style={{ marginBottom: '20px' }}>
          Invitation Configuration
        </h1>
      </Flex>
      <Box bg="white" p={5} my={10} borderRadius={6} boxShadow="lg" flex="1 1 auto">
        <Flex justifyContent="flex-end" mb={5}>
          <Button onClick={update} colorScheme="messenger" type="button" shadow="lg" ml="auto">
            Save
          </Button>
        </Flex>
        <CustomInput
          input={interval}
          tooltip="Invitations can expire after specific time interval. This is the configuration for setting up interval and interval type for expiration."
          label="Expiration configuration"
          name="interval"
          id="interval"
          placeholder="Interval"
          type="number"
        />
        <Select
          value={intervalType}
          onChange={(e) => setIntervalType(e.currentTarget.value)}
          placeholder="Interval type"
        >
          <option value="days">day/s</option>
          <option value="weeks">week/s</option>
          <option value="months">month/s</option>
        </Select>
      </Box>
    </>
  );
}

export default InvitationSettingsEditor;
